import {
  getSortConflictenOptions,
  SorteringRichting,
  type SorteringType,
} from '@/components/sidebar/sortField/useSorting';
import type { ConflictType } from '@/types/Conflicten';

const sortConflictenOptions = getSortConflictenOptions();
const defaultSortType = sortConflictenOptions[0];
const defaultValueSortDirection = SorteringRichting.UP;

export type ConflictenFilter = {
  eenheidOfTreinnummer?: string;
  dienstregelpunten?: string[];
  materieelTypen?: string[];
  conflictTypen?: ConflictType[];
  sorteringType?: SorteringType;
  sorteringRichting?: SorteringRichting;
  datumVan?: string;
  datumTotEnMet?: string;
};

export const defaultFilter = {
  sorteringType: defaultSortType.value,
  sorteringRichting: defaultValueSortDirection,
} satisfies ConflictenFilter;
